import NoSsr from '@eversports/klimt-design-components/NoSsr'
import Box from '@eversports/klimt-primitives/legacy/Box'
import Processing from '@eversports/klimt-primitives/legacy/Processing'
import Stack from '@eversports/klimt-primitives/legacy/Stack'
import Text from '@eversports/klimt-primitives/legacy/Text'

import { Localized } from '../../../../../../localization/react'

import FriendsUpcomingParticipationsBlock from './FriendsUpcomingParticipationsBlock'
import FriendsUpcomingParticipationsPlaceholder from './FriendsUpcomingParticipationsPlaceholder'
import getFriendsUpcomingParticipationsBlocks from './helpers/get-friends-upcoming-participations-blocks'
import useFriendsUpcomingParticipations from './hooks/useFriendsUpcomingParticipations'
import NoFriendsUpcomingParticipations from './NoFriendsUpcomingParticipations'

interface Props {
  userHandle: string
}

const FriendsUpcomingParticipations = ({ userHandle }: Props) => {
  const { friendsUpcomingParticipations, loading, initialLoading, fetchMore, hasMoreResults } =
    useFriendsUpcomingParticipations()

  if (initialLoading) {
    return <FriendsUpcomingParticipationsPlaceholder />
  }

  const friendsUpcomingParticipantsBlocks = getFriendsUpcomingParticipationsBlocks(friendsUpcomingParticipations)

  if (!friendsUpcomingParticipantsBlocks.length) {
    return <NoFriendsUpcomingParticipations userHandle={userHandle} />
  }

  return (
    <Stack gap={{ xs: 6, md: 4 }} paddingTop={{ xs: 4, md: 0 }}>
      {friendsUpcomingParticipantsBlocks.map((block) => (
        <FriendsUpcomingParticipationsBlock
          key={block.date}
          date={block.date}
          upcomingParticipations={block.upcomingParticipations}
        />
      ))}
      {hasMoreResults && (
        <Processing isLoading={loading}>
          <Box
            sx={{ backgroundColor: 'limelite', borderRadius: 1, padding: 2, width: '100%', cursor: 'pointer' }}
            onClick={fetchMore}
          >
            <Text variant="small" sx={{ color: 'primary.main', fontWeight: 'bold', textAlign: 'center' }}>
              <Localized id="load-more-upcoming-friends-participations-button" />
            </Text>
          </Box>
        </Processing>
      )}
    </Stack>
  )
}

const FriendsUpcomingParticipationsWrapper = ({ userHandle }: Props) => {
  return (
    <NoSsr fallback={<FriendsUpcomingParticipationsPlaceholder />}>
      <FriendsUpcomingParticipations userHandle={userHandle} />
    </NoSsr>
  )
}

export default FriendsUpcomingParticipationsWrapper
